import { render } from "./backUpLogin.vue?vue&type=template&id=6cf6d880&scoped=true"
import script from "./backUpLogin.vue?vue&type=script&lang=js"
export * from "./backUpLogin.vue?vue&type=script&lang=js"

import "./backUpLogin.vue?vue&type=style&index=0&id=6cf6d880&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf6d880"]])

export default __exports__